import styled from 'styled-components';

const StyledLayout = styled.div`
  position: relative;
  width: 1200px;
  max-width: 100%;
  margin-top: 150px;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (max-width: 1030px) {
    width: 90%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`;

export default StyledLayout;

